/**
 * @packageDocumentation
 * @module HackerAPI.Search
 */
import HackerAPIFetch from "../hackerapi-fetch/hackerapi-fetch";
import Airport from "./airport/airport";
import Institution from "../institution/institution";
import User from "./user/user";
import Member from "../event/team/member/member";
import Company from "../company/company";
import Event from "../event/event";
import Claim from "../claim/claim";
import { toUnderscoreKeys } from "../utils/utils";
/**
 * A static class with methods for searching various parts of the hackerapi database
 * @class
 */
var Search = /** @class */ (function () {
    function Search() {
    }
    Object.defineProperty(Search, "Airport", {
        /**
         * @returns
         */
        get: function () {
            return Airport;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Search, "User", {
        /**
         * @returns
         */
        get: function () {
            return User;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Searches the airport database with the given query string
     * @param query
     * @param query.q - Search string to use
     * @returns
     */
    Search.airports = function (query) {
        return HackerAPIFetch({
            path: "/v2/search/airports",
            method: "GET",
            params: query
        }).then(function (data) {
            return data.map(function (datum) { return new Airport(datum); });
        });
    };
    /**
     * Searches the school database with some or all of the query parameters
     * @param query
     * @param query.q - Search string
     * @param query.institutionType - One of "post-secondary", "high_school", "middle_school"
     * @param query.countryCode
     * @returns Note doesn't return address
     */
    Search.institutions = function (query) {
        return HackerAPIFetch({
            path: "/v2/search/institutions",
            method: "GET",
            params: toUnderscoreKeys(query)
        }).then(function (data) {
            return data.map(function (datum) { return new Institution(datum); });
        });
    };
    /**
     * Searches the user database for users matching the query string
     * @param query
     * @param query.q - Search string
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Search.users = function (query, token) {
        return HackerAPIFetch({
            path: "/v2/search/users",
            method: "GET",
            token: token,
            params: query
        }).then(function (data) { return data.map(function (datum) { return new User(datum); }); });
    };
    /**
     * Searches the team database for teams matching the query parameters
     * @param query
     * @param query.teamId
     * @param query.userId
     * @param query.event - The slug for an event
     * @param query.page - The page of teams to return
     * @param query.size - The maximum number of results to return
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Search.teams = function (query, token) {
        return HackerAPIFetch({
            path: "/v2/search/teams",
            method: "GET",
            token: token,
            params: toUnderscoreKeys(query)
        }).then(function (data) { return data.map(function (datum) { return new Member(datum); }); });
    };
    /**
     * Searches the company database for companies matching the query parameters
     * @param query
     * @param query.q
     * @returns
     */
    Search.companies = function (query) {
        return HackerAPIFetch({
            path: "/v2/search/companies",
            method: "GET",
            params: toUnderscoreKeys(query)
        }).then(function (data) {
            return data.map(function (datum) { return new Company(datum); });
        });
    };
    /**
     * Searches the claim database for claims matching the query parameters
     * @param query
     * @param query.q
     * @param query.event - Event slug
     * @param query.pipeline - Pipeline slug or id
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Search.claims = function (query, token) {
        return HackerAPIFetch({
            path: "/v2/search/claims",
            method: "GET",
            token: token,
            params: toUnderscoreKeys(query)
        }).then(function (data) { return data.map(function (datum) { return new Claim(datum); }); });
    };
    /**
     * Searches the event database for events matching the query parameters
     * @param query
     * @param query.q
     * @returns Only returns id, slug, name, startTime, endTime, website, createdAt and updatedAt fields
     */
    Search.events = function (query) {
        return HackerAPIFetch({
            path: "/v2/search/events",
            method: "GET",
            params: toUnderscoreKeys(query)
        }).then(function (data) { return data.map(function (datum) { return new Event(datum); }); });
    };
    /**
     * Perform an SQL query on the hackerapi database
     * @param query
     * @param query.sql - The SQL to execute (select only)
     * @returns The results of the query
     */
    Search.withSql = function (query) {
        return HackerAPIFetch({
            path: "/v2/database/query",
            method: "POST",
            body: toUnderscoreKeys(query)
        });
    };
    return Search;
}());
export default Search;
//# sourceMappingURL=search.js.map